import React from 'react';
import PropTypes from 'prop-types';
import ExpandableSection from '../../expandableSection';

const ResourceCountSection = ({
  expanded,
  onToggle,
  onDownload,
  getResourceCountSortClass,
  resourceCountSort,
  getAriaSort,
  handleResourceCountSort,
  resourceCountSortedData,
  resourceCountTotals,
  isLoading,
}) => (
  <ExpandableSection
    title="Resource allocation count"
    expanded={expanded}
    onToggle={onToggle}
    onDownload={onDownload}
    showMoreAction={false}
    isLoading={isLoading}
  >
    <div className="section-content resource-count-section">
      <div className="resource-count-table-wrapper">
        <div className="resource-count-table-scroll">
          <table className="resource-count-data-table">
            <thead>
              <tr>
                <th
                  className={`th-cell sortable ${getResourceCountSortClass('role')}`}
                  aria-sort={getAriaSort(
                    resourceCountSort.key,
                    'role',
                    resourceCountSort.direction,
                  )}
                >
                  <button
                    type="button"
                    className="th-content"
                    onClick={() => handleResourceCountSort('role')}
                  >
                    <span>Role</span>
                    <span className="sort-icon" />
                  </button>
                </th>
                <th
                  className={`th-cell sortable th-numeric ${getResourceCountSortClass('total')}`}
                  aria-sort={getAriaSort(
                    resourceCountSort.key,
                    'total',
                    resourceCountSort.direction,
                  )}
                >
                  <button
                    type="button"
                    className="th-content th-content-numeric"
                    onClick={() => handleResourceCountSort('total')}
                  >
                    <span>Total resource (Head count)</span>
                    <span className="sort-icon" />
                  </button>
                </th>
                <th
                  className={`th-cell sortable th-numeric ${getResourceCountSortClass('current')}`}
                  aria-sort={getAriaSort(
                    resourceCountSort.key,
                    'current',
                    resourceCountSort.direction,
                  )}
                >
                  <button
                    type="button"
                    className="th-content th-content-numeric"
                    onClick={() => handleResourceCountSort('current')}
                  >
                    <span>Current resource (Head count)</span>
                    <span className="sort-icon" />
                  </button>
                </th>
                <th
                  className={`th-cell sortable th-numeric ${getResourceCountSortClass('allocation')}`}
                  aria-sort={getAriaSort(
                    resourceCountSort.key,
                    'allocation',
                    resourceCountSort.direction,
                  )}
                >
                  <button
                    type="button"
                    className="th-content th-content-numeric"
                    onClick={() => handleResourceCountSort('allocation')}
                  >
                    <span>Current resource (Allocation)</span>
                    <span className="sort-icon" />
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              {resourceCountSortedData.map((row, idx) => (
                <tr key={row.id || idx} className="tr-data">
                  <td className="td-cell">{row.role || ''}</td>
                  <td className="td-cell td-numeric">{row.total || 0}</td>
                  <td className="td-cell td-numeric">{row.current || 0}</td>
                  <td className="td-cell td-numeric">{Number(row.allocation || 0).toFixed(2)}</td>
                </tr>
              ))}
              <tr className="tr-data total-row sticky-total-row">
                <td className="td-cell"><strong>Total</strong></td>
                <td className="td-cell td-numeric"><strong>{resourceCountTotals.total}</strong></td>
                <td className="td-cell td-numeric"><strong>{resourceCountTotals.current}</strong></td>
                <td className="td-cell td-numeric">
                  <strong>{Number(resourceCountTotals.allocation || 0).toFixed(2)}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ExpandableSection>
);

ResourceCountSection.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onDownload: PropTypes.func,
  getResourceCountSortClass: PropTypes.func.isRequired,
  resourceCountSort: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.string,
  }).isRequired,
  getAriaSort: PropTypes.func.isRequired,
  handleResourceCountSort: PropTypes.func.isRequired,
  resourceCountSortedData: PropTypes.array.isRequired,
  resourceCountTotals: PropTypes.shape({
    total: PropTypes.number,
    current: PropTypes.number,
    allocation: PropTypes.number,
  }).isRequired,
  isLoading: PropTypes.bool,
};

ResourceCountSection.defaultProps = {
  isLoading: false,
};

export default ResourceCountSection;
